import styles from "./Methodology.module.css"
import TranslationText from "./TranslationText"

export default function Methodology() {
    return (
    <div className={styles.Main}>
        <div className={styles.Title}><TranslationText value="read_bookr_methodology_to_learn"/></div>
        <div className={styles.Button}><TranslationText value="read_methodology"/></div>
    </div>)
}